import { IExperiment } from '../../types/experiments';

export function getExperimentGroup(experiments: IExperiment[] = [], name: string = ''): number | null {
  const experiment = experiments && experiments.find(e => e.name === name);

  return experiment ? experiment.abGroup : null;
}
